import * as React from 'react';

import {Button} from 'shells/button/button';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {ConnectionNextSteps} from '../../../connection-next-steps/connection-next-steps';

import {trackModalPageLoad} from '../track-page-load';

type Props = {
    onGoToSettings: () => void;
    currentUrl: string;
};

export function DoneNoSync(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Cool. You can always sync your email later</ModalHeader>
                <ModalSubheader>
                    You can now send emails from inside of Nutshell sent from your own email
                    address.
                </ModalSubheader>
                <ConnectionNextSteps />
            </ModalMain>
            <NavButtons>
                <Button variant='text' onClick={props.onGoToSettings}>
                    Review your settings
                </Button>
            </NavButtons>
        </RightFrame>
    );
}
